
import Vue from 'vue'

export default {
  getUser () {
    var url = 'https://zzv2ngo0k1.execute-api.us-west-2.amazonaws.com/prod/twitter/getuser?target=LowcoTV'
    var p1 = new Promise(function (resolve, reject) {
      Vue.http.get(url).then(response => {
        resolve(response)
      }, response => {
        // error goes here
        reject(response)
      })
    })
    return p1
  }
}



// WEBPACK FOOTER //
// ./src/gateways/twitter.js